import classnames from 'classnames';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { electOwningCase } from '../../../utils';
import EditEntityModal from './EditEntity/';

const CaseParticipantsListItem = (props) => {
  return (
    <li
      className="participant-list-item"
      key={props.id}
    >
      {props.item.firstName} {props.item.lastname}
      {
        props.item.editing &&
        <span className="isEditing">(Editing)</span>
      }
    </li>
  )
}

const CaseParticipantsSingleListItem = (props) => {
  return (
    <ul className="participant-list gdocs-responsive-text" key={"ul" + props.id}>
      {
        props.users.length > 0
          ? props.users.map(key1 =>
            <li
              className="participant-list-item"
              key={props.id}
            >
              {key1.firstName} {key1.lastname}
              {
                key1.editing &&
                <span className="isEditing">(Editing)</span>
              }
            </li>
          )
          : ''
      }
    </ul>
  )
}

class CaseParticipantsList extends Component {
  state = {
    isShowPlus: true,
    isShowMinus: false,
  }

  _collapse = (id) => {
    let selectedRef = `participants_${id}`;
    if (this[selectedRef].style.display === 'block') {
      this[selectedRef].style.display = "none"
      this.setState({
        isShowPlus: true,
        isShowMinus: false,
      })
    }
    else {
      this[selectedRef].style.display = "block";
      this.setState({
        isShowPlus: false,
        isShowMinus: true,
      })
    }
  }

  render() {
    const icon = classnames({
      'icon': true && this.props.users.length > 0 ? true : false,
      'icon-add': this.state.isShowPlus && this.props.users.length > 0 ? true : false,
      'icon-minimize': this.state.isShowMinus && this.props.users.length > 0 ? true : false,
      'gdocs-valign-bottom fontsize24': true
    })
    return (
      <li
        onClick={this._collapse.bind(this, this.props.id)}
        className="case-menu__list__item"
      >
        <span className={icon}></span>
        {this.props.item}
        {
          this.props.isEditing &&
          <span className="isEditing">(Editing)</span>
        }
        <ul
          ref={node => this[`participants_${this.props.id}`] = node}
          className="hide-section participant-list gdocs-responsive-text"
        >
          {
            this.props.users.map((item, key) => <CaseParticipantsListItem item={item} id={key} />)
          }
        </ul>
      </li>
    )
  }
}

class ParticipantSection extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpen: true,
      isCollapse: false,
      editentity: false,
      participantData: []
    }
  }

  _edit = (status) => {
    let _state = this.state;
    if (this.state.editentity === false) {
      _state['editentity'] = true;
    } else if (status === 'true') {
      _state['editentity'] = true;
      _state['RevokeaccessConfirm'] = true;
    } else {
      _state['editentity'] = false;
    }
    this.setState(_state);
  }

  _editOnEnter = (event) => {
    let _state = this.state;
    if (event.keyCode === 13 && this.state.editentity === false) {
      _state['editentity'] = true;
    } else if (event.keyCode === 13) {
      _state['editentity'] = true;
      _state['RevokeaccessConfirm'] = true;
    } else {
      _state['editentity'] = false;
    }
    this.setState(_state);
  }

  _callback = (value) => {
    this.props.getUpdatedCaseMenuValue(value);
  }

  isEditingUser = (user) => {
    let editUser = user.filter(function (userData) {
      return userData.isEditing
    });
    if (editUser.length > 0) {
      return true;
    }
    else {
      return false;
    }
  }

  render() {
    const { headerTitle, caseParticipants, modalRevokedAccessJson, lang, sowHeaderTitle } = this.props;
    if (caseParticipants.length > 1) {
      return (
        <div className="case-menu__section">
          <h2 className="case-menu__section__header gdocs-responsive-text">{this.props.sow ? sowHeaderTitle : headerTitle}
            {
              !this.props.customer &&
              <i onClick={this._edit} onKeyDown={this._editOnEnter} className="icon icon-edit" aria-label='edit-participants' role='button' tabIndex='0'></i>
            }
          </h2>
          <span className="case-menu__section__bar"></span>
          <ul className={this.state.isOpen === true ? `case-menu__list gdocs-responsive-text` : 'case-menu__list gdocs-responsive-text hide'}>
            {
              caseParticipants !== '' ? caseParticipants.map((item, key) =>
                <CaseParticipantsList
                  item={caseParticipants[key].entityName}
                  id={key}
                  users={caseParticipants[key].users}
                  isEditing={this.isEditingUser(caseParticipants[key].users)}
                />
              ) : ''
            }
          </ul>
          {
            this.state.editentity === true
              ? <EditEntityModal
                _edit={this._edit}
                _ReokeaccessConfrim={this.state.RevokeaccessConfirm}
                _entityName={caseParticipants}
                _caseId={this.props.sow ? this.props.sowEntities : this.props.owningCase.caseId}
                _callback={this._callback}
                _modalRevokedAccessJson={modalRevokedAccessJson}
                lang={lang}
                sow={this.props.sow}
                sowEntities={this.props.sowEntities}
              />
              : ""
          }
        </div>
      )
    } else {
      return (<div className="case-menu__section">
        <h2 className="case-menu__section__header gdocs-responsive-text">{this.props.sow ? sowHeaderTitle : headerTitle}
          {
            !this.props.customer &&
            <i onClick={this._edit} onKeyDown={(event) => this._editOnEnter(event)} className="icon icon-edit" aria-label='edit-SOW-participants' role='button' tabIndex='0'></i>
          }
        </h2>
        <span className="case-menu__section__bar"></span>
        <div className={this.state.isOpen === true ? `case-menu__list gdocs-responsive-text` : 'case-menu__list gdocs-responsive-text hide'}>
          {
            caseParticipants !== '' ? caseParticipants.map((item, key) =>
              <CaseParticipantsSingleListItem
                item={caseParticipants[key].entityName}
                id={key}
                users={caseParticipants[key].users}
              />
            ) : ''
          }
        </div>
        {
          this.state.editentity === true
            ? <EditEntityModal
              _edit={this._edit}
              _ReokeaccessConfrim={this.state.RevokeaccessConfirm}
              _entityName={caseParticipants}
              _caseId={this.props.sow ? this.props.sowEntities : this.props.owningCase.caseId}
              _callback={this._callback}
              _modalRevokedAccessJson={modalRevokedAccessJson}
              lang={lang}
              sow={this.props.sow}
              sowEntities={this.props.sowEntities}
            />
            : ""
        }
      </div>);
    }
  }
}

ParticipantSection.defaultProps = {
  headerTitle: 'undefined',
  caseParticipants: []
}
const mapStateToProps = state => {
  return {
    customer: state.auth.userDetails.roleDetails.customer,
    owningCase: electOwningCase(state.cases)
  }
}
export default connect(mapStateToProps, null)(ParticipantSection);



// WEBPACK FOOTER //
// ./src/components/common/CaseMenu/ParticipantSection.js